import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonBase, Container, Stack, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const NoAccessPageView: FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl">
      <Stack padding="30px" textAlign="center" gap="20px" alignItems="center">
        <LockIcon sx={{ fontSize: '80px', color: 'primary.main' }} />
        <Typography variant="h3" fontWeight={600}>
          403
        </Typography>
        <Typography variant="h4">Access Denied</Typography>
        <Typography variant="h6">
          Sorry, you don&apos;t have permission to access this page.
          <br />
          you can go back to{' '}
          <ButtonBase
            onClick={() => navigate(-1)}
            sx={{
              fontSize: 'inherit',
              fontWeight: 'inherit',
              color: 'primary.main',
            }}
          >
            <b>Previous Page</b>
          </ButtonBase>
        </Typography>
      </Stack>
    </Container>
  );
};

export default NoAccessPageView;
